import api from "../api";

export const useUpdatePropertyOccupancyStatus = (data) =>

    api.put(`/property/${data?.id}/occupancy-status`, data).then((res) => res.data);
